//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';
import {
  Autocomplete,
  IconButton,
  TextField,
  Tooltip,
} from '@mui/material';
import { Add, Search, ContentCopy, ExpandMore, ExpandLess } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer } from 'components/Spacer';

// === UTILS ===

// === API ===

//#endregion

//-----------------------------------------------------------------
export function ControlBox(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const theme    = useTheme   ();
  const navigate = useNavigate();

  const [ is_open_modal  , setIsOpenModal  ] = useState( false );
  const [ is_open_filter , setIsOpenFilter ] = useState( false );

  const expand_filter_icon = is_open_filter ? <ExpandLess /> : <ExpandMore />;

  const _tags = [
    { label: 'Is required document', group: 'Misc', filter: (rule) => rule.tags?.is_required_document },
  ];

  const search_value = localStorage.getItem( 'da-rule-list-search' );

  //#endregion

  //#region [STYLES]

  // === SX ===
  const _styles = {
    bar: {
      height       : 'max-content'   ,
      width        : '100%'   ,
      overflow     : 'hidden' ,
      borderRadius : '1rem'   ,
      overflow     : 'hidden' ,
      padding      : '1rem'   ,
    },
    container_main: {
      width   : '100%'   ,
      display : 'flex'   ,
      margin  : '0.5rem' ,
    },
    header_text: {
      fontSize: 'x-large',
      paddingLeft: '1rem',
      paddingTop: '0.8rem',
      color : theme.palette.primary.contrastColor,
    },
    search_text: {
      width: '100%',
      maxWidth: '50rem',
    },
    button_rule_add: {
      height: '3rem',
      margin: '0 0.5rem',
      whiteSpace: 'nowrap',
    },
    container_filter: {
      display: is_open_filter ? 'flex' : 'none',
      width: '100%',
      justifyContent: 'center',
    },
    filter_tags: {
      minWidth: '40rem',
    },
    header: {
      display: 'flex',
      fontSize: '2rem',
    },
  };

  // === ATTRIBUTES ===

  const HEADER = {
    style: _styles.header,
  };

  const
    CONTAINER = {
      style: _styles.bar,
    },
    CONTAINER_FILTER = {
      style: _styles.container_filter,
    },
    TEXT_SEARCH = {
      sx: _styles.search_text,
      label: 'Search...',
      value: search_value,
      size : 'small', 
      onChange : onChangeSearch,
    },
    BUTTON_ADD = {
      sx: _styles.button_add,
      children: <Add />,
      onClick: onClick_Add,
    },
    BUTTON_DUPLICATE = {
      sx: _styles.button_duplicate,
      children: <ContentCopy />,
      disabled: true,
      onClick: onClick_Duplicate,
    },
    BUTTON_EXPAND = {
      children: [expand_filter_icon],
      onClick: () => { setIsOpenFilter(!is_open_filter) }
    },
    FILTER_TAGS = {
      id          : 'filter-tags',
      sx          : _styles.filter_tags,
      multiple    : true,
      options     : _tags,
      groupBy     : (option) => option.group,
      renderInput : (params) => { return <TextField {...params} variant='standard' label="Filter Tags" /> },
      onChange    : (event, value) => { props.onFilter( value.map( x => x.filter ) ) },
    };

  //#endregion

  //#region [PROCES]
  
  props.onSearch( search_value?.toUpperCase() )

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick_Add(event) {
    //-----------------------------------------------------------------
    try {
      navigate( 'new' );
    } catch (error) {
      console.warn(error);
    }
  }

  //-----------------------------------------------------------------
  function onClick_Duplicate(event) {
    //-----------------------------------------------------------------
    try {

    } catch (error) {
      console.warn(error);
    }
  }

  //-----------------------------------------------------------------
  function onChangeSearch(event) {
    //-----------------------------------------------------------------
    try {
      const search = event.target.value;
      localStorage.setItem( 'da-rule-list-search', search );
      props.onSearch( search?.toUpperCase() )
    } catch (error) {
      console.warn(error);
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div { ...CONTAINER }>
        <div { ...HEADER }>
          <div>Rules:</div>
          <Spacer width='6rem' />
          <div>{props.count}</div>
          <Spacer fill />
          <IconButton> <Search /> </IconButton>
          <TextField { ...TEXT_SEARCH }/>
          <Spacer />
          <IconButton { ...BUTTON_EXPAND } />
          <Spacer fill />
          <Spacer width='6rem' />
          <Tooltip title='Add rule' placement='top'>
            <IconButton { ...BUTTON_ADD  } />
          </Tooltip>
          <Tooltip title='Duplicate rule' placement='top'>
            <IconButton { ...BUTTON_DUPLICATE } />
          </Tooltip>
          <IconButton { ...BUTTON_EXPAND } />
        </div>
        <div { ...CONTAINER_FILTER }>
          <Spacer fill />
          <Autocomplete { ...FILTER_TAGS }/>
          <Spacer fill />
        </div>
      </div>
    );
  }

  //#endregion

  return display();
}